import React from 'react';

import IZRULogo from '@assets/images/main/iz-ru-logo.svg';
import facebook from '@assets/images/social/facebook.svg';
import twitter from '@assets/images/social/twitter.svg';
import vk from '@assets/images/social/vk.svg';

export const PageFooter: React.FC = () => {
  return (
    <footer className="flex flex-col lg:flex-row justify-between items-start lg:items-center px-5 lg:py-0 mt-10 mb-8 lg:mt-14 lg:mb-14 m-auto w-full max-w-1144">
      <div className="flex flex-col lg:flex-row items-start lg:items-center">
        <a className="mr-10 mb-5 lg:mb-0" href="https://iz.ru/">
          <img src={IZRULogo} width="112" height="42" alt="" />
        </a>
        <p className="text-xs text-gray-500 max-w-xl mb-6 lg:mb-0">
          Зарегистрировано Федеральной службой по надзору в сфере связи, информационных технологий и массовых коммуникаций Свидетельство о регистрации ЭЛ № ФС 77 - 76208 от 8 июля 2019 года. Возрастные ограничения 18+
        </p>
      </div>

      <div className="flex flex-col lg:flex-row items-start lg:items-center">
        <span className="text-xs text-gray-500 mr-2.5 mb-5 lg:mb-0">
          Мы в социальных сетях:
        </span>
        <div className="flex">
          <a className="ml-0 lg:ml-5 transition hover:opacity-50" target="_blank" rel="noreferrer" href="http://facebook.com/izvestia.ru">
            <img src={facebook} width="10" height="19" alt="" />
          </a>
          <a className="ml-5 transition hover:opacity-50" target="_blank" rel="noreferrer" href="https://vk.com/izvestia">
            <img src={twitter} width="20" height="16" alt="" />
          </a>
          <a className="ml-5 transition hover:opacity-50" target="_blank" rel="noreferrer" href="https://twitter.com/izvestia_ru">
            <img src={vk} width="25" height="14" alt="" />
          </a>
        </div>
      </div>
    </footer>
  );
}